import React, { useState } from "react";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import FormButtons from "../../common/register/FormButtons";
import { codeBoxes } from "../../constants/constants";
import { toast, Toaster } from "react-hot-toast";
import { BASE_URL } from "../../constants/ApiUrls";
import { uUrls } from "../../constants/ApiUrls";
import { useTranslation } from "react-i18next";

const Confirmation = (props) => {
  const { t } = useTranslation();
  const { back, next, authToken } = props;
  const [validationCode, setValidationCode] = useState("");
  const handleChange = (evt) => {
    var elts = document.getElementsByClassName("code-box");
    let value = validationCode;
    setValidationCode(value);
    Array.from(elts).forEach((elt) => {
      elt.addEventListener("keyup", (event) => {
        if (elt.value.length === 1) {
          if (elts.length >= elt.nextElementSibling.id) {
            value = value + evt.target.value;
            elt.nextElementSibling.focus();
          } else {
            return;
          }
        }
      });
    });
  };
  const handleSubmit = async () => {
    try {
      const { data } = await axios.put(
        BASE_URL + uUrls.PHONE_NUMBER_VERIFICATION,
        {
          verificatioCode: 123456,
        },
        {
          headers: {
            Authorization: `Bearer  ${authToken}`,
          },
        }
      );
      // toast.success(data?.message);
      next();
    } catch (error) {
      setValidationCode("");
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <>
      <Toaster />
      <Typography variant="h4" fontWeight="bold" color="color.magentaDark1">
        {t("confirm-phone")}
      </Typography>

      <Box component="div" marginTop="4rem">
        <Typography variant="h6">{t("verification-code")}</Typography>
        <Box component="div" className="code-boxes">
          {codeBoxes?.map((item) => (
            <input
              key={item}
              type="text"
              id={item}
              className="code-box"
              maxLength={1}
              onChange={(e) => handleChange(e, `v${item}`)}
            />
          ))}
        </Box>
      </Box>
      <FormButtons back={back} click={handleSubmit} />
    </>
  );
};

export default Confirmation;
